import { compose, eq, get, negate } from "lodash/fp"

export const entityIdDoesNotEqualId = (id: string) => {
  return compose(negate(eq(id)), get("id"))
}
